import { useDispatch } from 'react-redux';

import { setContextMenu } from 'craft/state';

export const useOnCloseMenu = () => {
  const dispatch = useDispatch();
  return () => dispatch(setContextMenu(undefined));
};
